// extracted by mini-css-extract-plugin
export default {"container":"coupons_container__vq+ek","wrapper":"coupons_wrapper__FkRT7","main":"coupons_main__a5Ma3","button":"coupons_button__V3tFP"};